import RoundTimer from "./RoundTimer";

const WinnerOverlay = ({
  winnerName,
  winnerTeamName,
  isMe,
  timerEndAt,
  timerDuration,
  theme,
  onReset,
  onSuspend,
  isHost,
}) => {
  return (
    <div className="absolute inset-0 z-50 flex flex-col items-center justify-center bg-black/80 backdrop-blur-md animate-in fade-in duration-300 overflow-y-auto py-6">
      {/* Confetti effect */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(30)].map((_, i) => (
          <div
            key={i}
            className="absolute w-2 h-2 rounded-full animate-pulse"
            style={{
              background: ['#FF0055', '#00F0FF', '#FFEA00'][i % 3],
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 2}s`,
              animationDuration: `${1 + Math.random() * 2}s`
            }}
          />
        ))}
      </div>

      {/* Winner Content */}
      <div className="relative z-10 text-center px-4 w-full max-w-2xl">
        {/* Countdown for the buzzed-in player (and anyone else watching) */}
        {timerEndAt && (
          <div className="mb-6">
            <RoundTimer endAt={timerEndAt} duration={timerDuration} theme={theme} />
          </div>
        )}

        <h2
          className="text-5xl sm:text-6xl short:text-3xl font-primary text-white mb-4 short:mb-2"
          style={{ fontFamily: 'Anton, sans-serif' }}
        >
          {isMe ? "YOU'RE UP!" : "WINNER!"}
        </h2>

        {/* Team name (only shown in team mode) sits above the player name in big cyan letters */}
        {winnerTeamName && (
          <p
            className="text-[#00F0FF] font-primary text-4xl sm:text-6xl short:text-2xl tracking-tight drop-shadow-[0_0_20px_rgba(0,240,255,0.8)] text-center px-4 mb-2 short:mb-1 break-words max-w-4xl"
            style={{ fontFamily: 'Anton, sans-serif' }}
            data-testid="winner-team-name"
          >
            {winnerTeamName}
          </p>
        )}

        <p
          className="text-[#FFEA00] font-primary text-6xl sm:text-8xl short:text-4xl tracking-tight drop-shadow-[0_0_20px_rgba(255,234,0,0.8)] text-center px-4 mb-4 short:mb-2 break-words max-w-4xl"
          style={{ fontFamily: 'Anton, sans-serif' }}
          data-testid="winner-name"
        >
          {winnerName}
        </p>

        <div className="flex items-center justify-center gap-2 text-[#00F0FF] mb-8">
          <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M5 2a1 1 0 011 1v1h1a1 1 0 010 2H6v1a1 1 0 01-2 0V6H3a1 1 0 010-2h1V3a1 1 0 011-1zm0 10a1 1 0 011 1v1h1a1 1 0 110 2H6v1a1 1 0 11-2 0v-1H3a1 1 0 110-2h1v-1a1 1 0 011-1zM12 2a1 1 0 01.967.744L14.146 7.2 17.5 9.134a1 1 0 010 1.732l-3.354 1.935-1.18 4.455a1 1 0 01-1.933 0L9.854 12.8 6.5 10.866a1 1 0 010-1.732l3.354-1.935 1.18-4.455A1 1 0 0112 2z" clipRule="evenodd" />
          </svg>
          <span className="text-xl">
            {isMe && timerEndAt ? "Answer now!" : "Pressed First!"}
          </span>
          <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M5 2a1 1 0 011 1v1h1a1 1 0 010 2H6v1a1 1 0 01-2 0V6H3a1 1 0 010-2h1V3a1 1 0 011-1zm0 10a1 1 0 011 1v1h1a1 1 0 110 2H6v1a1 1 0 11-2 0v-1H3a1 1 0 110-2h1v-1a1 1 0 011-1zM12 2a1 1 0 01.967.744L14.146 7.2 17.5 9.134a1 1 0 010 1.732l-3.354 1.935-1.18 4.455a1 1 0 01-1.933 0L9.854 12.8 6.5 10.866a1 1 0 010-1.732l3.354-1.935 1.18-4.455A1 1 0 0112 2z" clipRule="evenodd" />
          </svg>
        </div>

        {isHost && (
          <div className="mt-4 flex flex-col sm:flex-row gap-3 items-center justify-center">
            <button
              onClick={onSuspend}
              className="px-6 py-3 bg-[#FF0055]/20 text-[#FF0055] border-2 border-[#FF0055]/60 font-secondary text-base sm:text-lg rounded-full hover:bg-[#FF0055]/30 transition-all active:scale-95 whitespace-nowrap"
              data-testid="suspend-winner-button"
            >
              ✕ Wrong — Lock & Continue
            </button>
            <button
              onClick={onReset}
              className="px-6 py-3 bg-white/10 text-white font-secondary text-base sm:text-lg rounded-full border border-white/20 hover:bg-white/20 transition-all active:scale-95 whitespace-nowrap"
              data-testid="reset-buzzer-button"
            >
              ✓ Reset for Next Question
            </button>
          </div>
        )}

        {!isHost && (
          <p className="mt-4 text-[#A1A1AA] text-sm">
            Waiting for host to reset...
          </p>
        )}
      </div>
    </div>
  );
};

export default WinnerOverlay;
